<template>
    <v-app :class="{'offline':!connected}">
        <component :is="layout">
            <router-view />
        </component>
        <Notifications />
        <v-progress-linear indeterminate color="primary" v-show="loading"></v-progress-linear>
    </v-app>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    import Notifications from '@/components/SysNotifications';

    export default {
        name: "App",

        components: {
            Notifications,
        },

        data: () => ({}),

        computed: {
            ...mapGetters("appshell", ["dark", "connected", "loading", "updateInProgress"]),

            layout() {
                return (this.$route.meta && this.$route.meta.layout) || "default-layout";
            }
        },
        watch: {
            dark(enabled) {
                this.$vuetify.theme.dark = enabled;
            },
            updateInProgress(v, ov) {
                if (v) {
                    this.$router.push("/pwa-update");
                }
            },
        },
        methods: {
            _setAuth0Client() {
                // init Auth0 Client on store:

                this.$store.dispatch("auth/init", {
                    logo: "https://parked.blob.core.windows.net/web/resources/logos/parked_dark.svg",
                    color: this.$vuetify.theme.themes.dark.primary
                });

            },

            _setDynamicManifest() {
                var slug = "mng";
                const manifestURL = "https://parked.blob.core.windows.net/web/" + slug + '/manifest.json';
                const fabiconURL = "https://parked.blob.core.windows.net/web/" + slug + '/icons/favicon.ico';
                const fabicon32URL = "https://parked.blob.core.windows.net/web/" + slug + '/icons/favicon-32x32.png';
                const fabicon16URL = "https://parked.blob.core.windows.net/web/" + slug + '/icons/favicon-16x16.png';
                const appleIconURL = "https://parked.blob.core.windows.net/web/" + slug +
                    '/icons/apple-icon-144x144.png';

                document.querySelector('link[rel="manifest"]').setAttribute('href', manifestURL);

                document.querySelector('meta[name="theme-color"]').setAttribute('content', this.$vuetify.theme.themes
                    .dark.primary);
                document.querySelector('meta[name="msapplication-TileImage"]').setAttribute('content', appleIconURL);

                document.querySelector('link[rel="icon"]').setAttribute('href', fabiconURL);
                document.querySelector('link[rel="icon"][sizes="32x32"]').setAttribute('href', fabicon32URL);
                document.querySelector('link[rel="icon"][sizes="16x16"]').setAttribute('href', fabicon16URL);
                document.querySelector('link[rel="apple-touch-icon"]').setAttribute('href', appleIconURL);
            },
        },

        async created() {
            this.$vuetify.theme.dark = this.dark;
            this._setAuth0Client();
            this._setDynamicManifest();
        }
    };
</script>

<style lang="scss">
    @import "assets/app.scss";

    #app.offline {
        filter: grayscale(0.8);
    }

    @media print {
        #header {
            display: none;
        }

        #drawer {
            display: none;
        }

        .v-content {
            width: 100% !important;
            padding: 20px !important;
        }
    }
</style>